
export class Dre {
    receitaOperacionalBruta!: number;
    receitaPrestacaoServicosNacional!: number;
    receitaPrestacaoServicosExterior!: number;
    outrasReceitas!: number;
    deducoesReceitaBruta!: number;
    vendasCanceladas!: number;
    descontosIncondicionais!: number;
    demaisTributosPrestacaoServicos!: number;
    receitaOperacionalLiquida!: number;
    custoServicosPrestados!: number;
    lucroBruto!: number;
    despesasOperacionais!: number;
    proLaboreSocios!: number;
    salariosRemuneracoesEmpregados!: number;
    encargosSociaisPrevidencia!: number;
    encargosSociaisFGTS!: number;
    encargosSociaisOutros!: number;
    outrasDespesasOperacionais!: number;
    receitasFinanceiras!: number;
    despesasFinanceiras!: number;
    resultadoLiquidoAntesParticipacoes!: number;
    participacoesEmpregados!: number;
    participacoesSocios!: number;
    resultadoLiquidoExercicio!: number;
  }
  